export default "__VITE_ASSET__CFyn$NOD__"